export const getSmartVoucherError = (response: any): { errorDescription: string; isEligible: boolean } => {
	const code: string = response?.errorDesc || '';
	let errorDescription: string = '';
	var isEligible = false;
	if (code.includes('INVALID_ACCOUNT_CATEGORY')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.invalid.account.category';
	} else if (code.includes('CLOSED_BALANCE')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.closed.balance';
	} else if (code.includes('NOT_CONFIGURED')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.not.configured';
	} else if (code.includes('DEVICE_COMMITMENT_EXISTS')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.device.commitments.exists';
	} else if (code.includes('NOT_ACTIVE')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.not.active';
	} else if (code.includes('INVALID_DISCOUNT')) {
		errorDescription = 'purchase.bulk.devices.voucher.warning.invalid.discount';
	}
	else {
		errorDescription = 'error.generic-title';
		isEligible = true;
	}

	return { errorDescription, isEligible };
};
